module.exports = __webpack_public_path__ + "img/thumb-005-08.bc6de2ff.png";